import { Component, OnInit } from '@angular/core';
import { HttpService } from '../../http.service';

@Component({
  selector: 'app-front-other',
  templateUrl: './front-other.component.html',
  styleUrls: ['./front-other.component.scss']
})
export class FrontOtherComponent implements OnInit {

  public data : any = {};
  public color: string = '#ffffff';
  public systemConfig: any = { 'whatsapp/api_url': '', 'whatsapp/api_key': '' };

  constructor(private http: HttpService) { }

  async getFile(fileInput: any, key: string) {
    try {
      const t : any = await this.http.fileChangeEvent(fileInput);
      this.data[key] = t.replace("unsafe:", "")
    } catch (error) {
      this.http.notify(error)
    }
  }

  ngOnInit(): void {
    this.init();
  }

  async init() {
    this.data = await this.http.post("/admin/setting/get");
    try {
      this.systemConfig = await this.http.post('/admin/system-config/get');
    } catch (_) {}
  }

  async submit() {
    const t = await this.http.post("/admin/setting/save", this.data);
    this.http.notify("Data update successfully.")
  }

  async saveSystemConfig() {
    await this.http.post('/admin/system-config/save', this.systemConfig);
    this.http.notify("WhatsApp config saved.")
  }
}
